import { render } from "./TheAuth.vue?vue&type=template&id=46d3341e&scoped=true"
import script from "./TheAuth.vue?vue&type=script&lang=js"
export * from "./TheAuth.vue?vue&type=script&lang=js"

import "./TheAuth.vue?vue&type=style&index=0&id=46d3341e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d3341e"]])

export default __exports__